const Cookie = {
    get: function (name) {
        let value = "; " + document.cookie;
        let parts = value.split("; " + name + "=");
        if (parts.length == 2) return parts.pop().split(";").shift();
    },
    set: function (name, value, expiry_days) {
        let d = new Date();
        d.setTime(d.getTime() + (expiry_days * 24 * 60 * 60 * 1000));
        let expires = "expires=" + d.toUTCString();
        let path = "path=/"; // sets it domain wide
        document.cookie = name + "=" + value + "; " + expires + "; " + path;
    }
};

export default Cookie;